import { Flex, Link } from '@chakra-ui/react';
import React from 'react';
import { useConfig } from '../../hooks/useConfig';

interface FooterProps {
  textColor?: string;
}

export const Footer: React.FC<FooterProps> = ({ textColor = 'current' }) => {
  const firebaseConfig = useConfig();
  return (
    <Flex
      align="center"
      w="full"
      justify="center"
      px={[3, 6]}
      pt={[3, 6]}
      pb={[3, 6]}
      h="50px"
      color={textColor}
    >
      <Link mx={3} target="_blank" href={firebaseConfig?.imprintUrl || ''}>
        Impressum
      </Link>
      <Link mx={3} target="_blank " href={firebaseConfig?.privacyUrl || ''}>
        Datenschutz
      </Link>
    </Flex>
  );
};
